import { render, staticRenderFns } from "./NewsMenuMod.vue?vue&type=template&id=5dd556ac&scoped=true"
import script from "./NewsMenuMod.vue?vue&type=script&lang=js"
export * from "./NewsMenuMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd556ac",
  null
  
)

export default component.exports